import { render, staticRenderFns } from "./checkRole.vue?vue&type=template&id=2f6540ed&scoped=true"
import script from "./checkRole.vue?vue&type=script&lang=js"
export * from "./checkRole.vue?vue&type=script&lang=js"
import style0 from "./checkRole.vue?vue&type=style&index=0&id=2f6540ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6540ed",
  null
  
)

export default component.exports